module.exports = __webpack_public_path__ + "img/max-file-content-deny.7a55b8be.svg";